<script>
import Component from '~/sites/shop/pages/search/index'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/hledat',
      de: '/suche',
      en: '/search',
      sk: '/hladat',
    },
  },
}
</script>
